// Rendert een rustig, professioneel antwoord. Ruimt eventuele markdown-opmaak op
// (koppen met #, sterretjes, streepjes) en toont opsommingen als nette bullets.

const renderInline = (text) => {
  const cleaned = text.replace(/`/g, "");
  const parts = cleaned.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) {
      return <strong key={i} className="font-semibold text-slate-900">{p.slice(2, -2)}</strong>;
    }
    return <span key={i}>{p.replace(/\*/g, "")}</span>;
  });
};

export const FormattedAnswer = ({ text, testId = "answer-text" }) => {
  const lines = (text || "").split("\n");
  const blocks = [];
  let bullets = [];

  const flushBullets = () => {
    if (bullets.length) {
      blocks.push({ type: "ul", items: bullets });
      bullets = [];
    }
  };

  lines.forEach((raw) => {
    const line = raw.trim();
    if (!line) { flushBullets(); return; }

    const heading = line.match(/^#{1,6}\s*(.+)$/);
    if (heading) {
      flushBullets();
      blocks.push({ type: "heading", text: heading[1].replace(/[*#]/g, "").trim() });
      return;
    }

    const bullet = line.match(/^[-*•]\s+(.+)$/);
    if (bullet) {
      bullets.push(bullet[1]);
      return;
    }

    flushBullets();
    blocks.push({ type: "p", text: line });
  });
  flushBullets();

  return (
    <div data-testid={testId} className="text-slate-800 leading-relaxed border-l-4 border-slate-900 pl-4 space-y-3">
      {blocks.map((b, i) => {
        if (b.type === "heading") {
          return <p key={i} className="font-semibold text-slate-900">{renderInline(b.text)}</p>;
        }
        if (b.type === "ul") {
          return (
            <ul key={i} className="space-y-1.5">
              {b.items.map((it, j) => (
                <li key={j} className="flex gap-2">
                  <span className="text-slate-400 mt-0.5 shrink-0">•</span>
                  <span>{renderInline(it)}</span>
                </li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{renderInline(b.text)}</p>;
      })}
    </div>
  );
};

export default FormattedAnswer;
